import React from "react"
import Collapsible from "react-collapsible"

import Plus from "@assets/icons/plus.inline.svg"
import Minus from "@assets/icons/minus.inline.svg"

import * as s from "./FAQ.module.scss"

export const FAQ = ({ data }) => {
  const questions = data.questions
  const title = data.title

  return (
    <div className={`${s.accordion}`}>
      {title && <h3 className={s.accordion__title}>{title}</h3>}

      {questions.map((item, i) => {
        return (
          <div key={i} className={`${s.accordion__wrapper}`}>
            <Collapsible
              triggerWhenOpen={
                <div className={s.accordion__container}>
                  <h5>{item.question}</h5>
                  <Minus className={s.accordion__triggerClose} />
                </div>
              }
              trigger={
                <div className={s.accordion__container}>
                  <h5>{item.question}</h5>

                  <Plus className={s.accordion__triggerPlus} />
                </div>
              }
            >
              <div
                dangerouslySetInnerHTML={{ __html: item.answer }}
                className={s.accordion__triggerBlurb}
              />
            </Collapsible>
          </div>
        )
      })}
    </div>
  )
}
